/**
 * Configuration for attribute indicator colors and labels.
 * Colors are chosen to work well in both light and dark modes.
 */
export const ATTRIBUTE_INDICATORS: Record<
	string,
	{
		color: string;
		shadowColor: string;
		label: string;
	}
> = {
	power: {
		color: '#ef4444', // red-500
		shadowColor: 'rgba(239, 68, 68, 0.4)',
		label: 'Power',
	},
	ground: {
		color: '#8b5cf6', // violet-500
		shadowColor: 'rgba(139, 92, 246, 0.4)',
		label: 'Ground',
	},
	analog: {
		color: '#06b6d4', // cyan-500
		shadowColor: 'rgba(6, 182, 212, 0.4)',
		label: 'Analog',
	},
	digital: {
		color: '#3b82f6', // blue-500
		shadowColor: 'rgba(59, 130, 246, 0.4)',
		label: 'Digital',
	},
	exposedPad: {
		color: '#f59e0b', // amber-500
		shadowColor: 'rgba(245, 158, 11, 0.4)',
		label: 'Exposed Pad',
	},
	noConnect: {
		color: '#6b7280', // gray-500
		shadowColor: 'rgba(107, 114, 128, 0.4)',
		label: 'No Connect',
	},
	activeLow: {
		color: '#ec4899', // pink-500
		shadowColor: 'rgba(236, 72, 153, 0.4)',
		label: 'Active Low',
	},
};
